var watchlistEdit = {
	confirmBtn: "Ok",
	cancelBtn: "Annuler",
	title: "Modifier liste",
	nameInputLabel: "Nom Liste",
	nameInputTip: "Max. 100 caractères – Caractères valides: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	placeholder: "Nouveau Nom",
	validationErrors: {
		name: {
			invalidInput: "Le nom n'est pas valide. Max. 100 caractères – Caractères valides: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var fr = {
	watchlistEdit: watchlistEdit
};

export { fr as default, watchlistEdit };
